import React, { useState } from 'react';
import { useVideo } from '../../../contexts/VideoContext';
import './Steps.css';

const Step1PetName = () => {
  const { videoData, updateVideoData, nextStep } = useVideo();
  const [petName, setPetName] = useState(videoData.petName || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!petName.trim()) {
      setError('Please enter your pet\'s name');
      return;
    }

    if (petName.trim().length < 2) {
      setError('Pet name must be at least 2 characters');
      return;
    }

    updateVideoData({ petName: petName.trim() });
    nextStep();
  };

  return (
    <div className="wizard-step">
      <div className="step-content">
        <div className="step-icon">🐕</div>
        <h2 className="step-title">What's Your Pet's Name?</h2>
        <p className="step-description">
          Let's start by telling us about your furry friend!
        </p>

        <form onSubmit={handleSubmit} className="step-form">
          <div className="form-group">
            <input
              type="text"
              value={petName}
              onChange={(e) => {
                setPetName(e.target.value);
                setError('');
              }}
              placeholder="Enter pet's name"
              className="form-input"
              autoFocus
            />
            {error && <div className="error-message">{error}</div>}
          </div>

          <button type="submit" className="btn-primary">
            Next Step
            <span className="btn-icon">→</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Step1PetName;
